export enum DoorLockCode {
  H21 = 'H21',
  BIDA = 'BIDA',
  YANGGE = 'YANGGE',
  CHUANGJIA = 'CHUANGJIA',
  PengZe = 'PengZe',
  BE_LINE = 'BE_LINE',
}

// 必达初始化 是否加密
export const DoorLockEncodeMap = {
  1: 'encode',
  0: 'none_encode',
};

// 是否启用,0启用1未启用
export enum DoorStatus {
  Usable = 0,
  Unusable = 1,
}
export interface DoorLockItem {
  id: number;
  name: string;
  description: string;
  lockCode: DoorLockCode;
  dbRoot: string;
  dbPass: string;

  status: DoorStatus;
  /**
   * 前端临时状态
   * */
  hotelId: number;
  // 必达数据库密码是否填写过
  isWriteRootPass: boolean;
  dbAddress: string;
  encryptionFlag: 0 | 1; // 0不加密 1加密
  // 杨格
  isLoadedYangge: boolean;
  isLoadedChuangJia: boolean;
  isLoadedPengZe: boolean;
  isLoadedBeLine: boolean;
}

export type H21Info = Pick<DoorLockItem, 'name' | 'lockCode' | 'hotelId'>;
export type BIDAInfo = Pick<DoorLockItem, 'name' | 'lockCode' | 'dbRoot' | 'dbPass'>;
export type YANGGEInfo = Pick<DoorLockItem, 'name' | 'lockCode'>;

// 房卡初始化弹窗
export type InitModalCallback = { initCallback: (params: Partial<DoorLockItem>) => void };
export interface InitModalRef {
  openModal: (params: Partial<DoorLockItem> & { cardInstance?: any } & InitModalCallback) => void;
}
